import { render, staticRenderFns } from "./AppointmentSelect.vue?vue&type=template&id=072b06d0&scoped=true"
import script from "./AppointmentSelect.vue?vue&type=script&lang=js"
export * from "./AppointmentSelect.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSelect.vue?vue&type=style&index=0&id=072b06d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b06d0",
  null
  
)

export default component.exports